// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"490":"bee92d30","838":"468b48ec","980":"b4a8ae9c"}[chunkId] + ".chunk.css";
};